import { useQuery } from '@apollo/client';

import ForceSSOLoginQuery from 'bundles/authentication-common/queries/ForceSSOLoginQuery.graphql';
import type {
  ForceSsoLoginQuery,
  ForceSsoLoginQueryVariables,
} from 'bundles/authentication-common/queries/__generated__/ForceSSOLoginQuery';

const useForceSSOLoginQuery = (organizationId: string) => {
  const { data, loading } = useQuery<ForceSsoLoginQuery, ForceSsoLoginQueryVariables>(ForceSSOLoginQuery, {
    skip: !organizationId,
    context: { clientName: 'gatewayGql' },
    variables: { orgId: organizationId },
  });

  const forceSSOLogin = !!data?.EntSso?.queryIfSsoForceLoginByOrgId?.isSsoLoginForced;

  return { forceSSOLogin, loading };
};

export default useForceSSOLoginQuery;
